// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"b60a9a36","700":"61250bb2","702":"3bae65bc","789":"feeb788c","908":"163b95fe","955":"91958686"}[chunkId] + ".css";
};